import { render, staticRenderFns } from "./LinkWithArrow.vue?vue&type=template&id=6707cdcb&lang=pug&"
import script from "./LinkWithArrow.vue?vue&type=script&lang=js&"
export * from "./LinkWithArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports